import { diff } from 'deep-diff';
import _difference from 'lodash/difference';
import dropRight from 'lodash/dropRight';
import get from 'lodash/get';
import has from 'lodash/has';
import isEqual from 'lodash/isEqual';
import isNumber from 'lodash/isNumber';
import last from 'lodash/last';
import omit from 'lodash/omit';
import pull from 'lodash/pull';
import set from 'lodash/set';
import some from 'lodash/some';

// src/helpers/refresh.ts
var getMergedData = ({
  newData,
  originData,
  data
}) => {
  let differences = diff(originData, data);
  const changedArrays = [];
  const someFn = (element, array) => {
    return isEqual(element, array);
  };
  differences = differences ? differences.filter((difference) => {
    if (difference.kind === "E" && isNumber(last(difference.path)) && difference.path.length > 1) {
      const path = dropRight(difference.path);
      const element = get(newData, path.join("."));
      if (Array.isArray(element)) {
        if (!some(changedArrays, (item) => someFn(item, path))) {
          changedArrays.push(path);
        }
        return false;
      }
    }
    if (difference.kind === "A") {
      if (!some(changedArrays, (item) => someFn(item, difference.path))) {
        changedArrays.push(difference.path);
      }
      return false;
    }
    return true;
  }) : [];
  changedArrays.forEach((changedArray) => {
    const originalArray = get(originData, changedArray.join("."));
    const newArray = get(data, changedArray.join("."));
    const deletedElements = _difference(originalArray, newArray);
    const addedElements = _difference(newArray, originalArray);
    deletedElements.forEach(
      (element) => differences.push({
        kind: "A",
        path: changedArray,
        item: {
          lhs: "",
          kind: "D",
          rhs: element
        }
      })
    );
    addedElements.forEach(
      (element) => differences.push({
        kind: "A",
        path: changedArray,
        item: {
          lhs: "",
          kind: "N",
          rhs: element
        }
      })
    );
  });
  const setArrayDiff = (difference) => {
    var _a, _b;
    const newArray = get(newData, difference.path.join("."));
    if (!Array.isArray(newArray)) {
      return;
    }
    if (((_a = difference.item) == null ? void 0 : _a.kind) === "N") {
      if (!newArray.includes(difference.item.rhs)) {
        set(
          newData,
          `${difference.path.join(".")}`,
          newArray.concat(difference.item.rhs)
        );
      }
    } else if (((_b = difference.item) == null ? void 0 : _b.kind) === "D") {
      if (newArray.includes(difference.item.rhs)) {
        set(
          newData,
          `${difference.path.join(".")}`,
          pull(newArray, difference.item.rhs)
        );
      }
    }
  };
  differences = differences.filter(
    (difference) => difference.kind === "E" ? has(newData, difference.path.join(".")) : true
  );
  differences.forEach((difference) => {
    const { kind, path } = difference;
    switch (kind) {
      case "E":
      case "N":
        set(newData, `${difference.path.join(".")}`, difference.rhs);
        break;
      case "D":
        newData = omit(newData, path.join("."));
        break;
      case "A":
        setArrayDiff(difference);
        break;
    }
  });
  return newData;
};

export { getMergedData };
